import React from "react";

import { monto } from "../promoApplications/formato";

/* Formato del Catálogo de Promos, compartido por la lista y la ventana de cada promo. */

type Promo = any;
export type Pestana = "vigentes" | "porEmpezar" | "vencidas";
export const LA_DA: Record<string, string> = { asesora: "Asesora", caja: "Caja", supervisora: "Supervisora" };
export const fecha = (d: string | null | undefined) => d ? d.slice(8, 10) + "/" + d.slice(5, 7) + "/" + d.slice(0, 4) : "";
export const num = (n: number) => (Math.round((Number(n) || 0) * 100) / 100).toLocaleString("es-MX", { maximumFractionDigits: 2 });

/** "10 %", "Precio Fijo $1,000", "$500 Menos", "Paga 8, Regala 4". */
export const valorTexto = (p: Promo, sym: string): string => {
	const r = p.rules || {};
	const m = (n: number) => monto(sym, n).replace(/\.00$/, "");
	if (r.monthsPaid && r.monthsFree) return `Paga ${r.monthsPaid}, Regala ${r.monthsFree}`;
	if (r.freeLast) return `Paga ${r.monthsTotal ? r.monthsTotal - r.freeLast : "los Primeros"}, Regala ${r.freeLast}`;
	if (r.freeSecond) return "Paga 1, el 2do Gratis";
	const extra = (r.freeFirst ? ` · ${r.freeFirst === 1 ? "1ra" : "Primeras " + r.freeFirst} en ${m(0)}` : "") + (r.subscriptionCharge ? ` · Inscripción ${m(r.subscriptionCharge)}` : "");
	if (extra && p.calcType === "percent") return num(p.value) + " %" + extra;
	if (p.calcType === "percent") return (p.value >= 100 ? "Gratis" : num(p.value) + " %") + (r.monthFrom ? ` (Mes ${r.monthFrom}${r.monthTo && r.monthTo !== r.monthFrom ? "–" + r.monthTo : ""})` : "");
	if (p.calcType === "fixed_price") return `Precio Fijo ${m(p.value)}`;
	return `${m(p.value)} Menos`;
};

/** Pestaña de cada promo: por fechas; la desactivada va con las Vencidas. */
export const pestanaDe = (p: Promo, hoy: string): Pestana => {
	if (!p.active) return "vencidas";
	if (p.validFrom && p.validFrom > hoy) return "porEmpezar";
	if (p.validTo && p.validTo < hoy) return "vencidas";
	return "vigentes";
};

/** La pastilla de vigencia: Desactivada / Venció / Empieza en oro; Hasta / Estable en naranja. */
export const Vigencia: React.FC<{ p: Promo; hoy: string }> = ({ p, hoy }) => {
	const t = pestanaDe(p, hoy);
	if (!p.active) return <span className="wdChip wdChipOro">Desactivada</span>;
	if (t === "vencidas") return <span className="wdChip wdChipOro">Venció {fecha(p.validTo)}</span>;
	if (t === "porEmpezar") return <span className="wdChip wdChipFilo">Empieza {fecha(p.validFrom)}</span>;
	return <span className="wdChip wdChipAcento">{p.validTo ? "Hasta " + fecha(p.validTo) : "Estable"}</span>;
};

